/**
 * **英文词典。**
 *
 * 键必须与 `zh.ts` 一致 —— `test/i18n.test.ts` 会逐个核对，缺一条就报。
 * 这里刻意**不写 `Record<TextKey, string>`**：迁移期间允许暂时缺，
 * 由测试兜住，而不是让编译器在做到一半时全红。
 */

import common from './en/common';
import menu from './en/menu';
import room from './en/room';
import settings from './en/settings';
import credit from './en/credit';
import game from './en/game';
import render from './en/render';
import core from './en/core';
import host from './en/host';
import audio from './en/audio';
import packs from './en/packs';
import debug from './en/debug';
import dev from './en/dev';
import type { TextSpec } from './text';

export const en: Record<string, TextSpec> = {
  ...common,
  ...menu,
  ...room,
  ...settings,
  ...credit,
  ...game,
  ...render,
  ...core,
  ...host,
  ...audio,
  ...packs,
  ...debug,
  ...dev,
};
